import React, { Component } from "react";
import Heading from "@components/Heading";

class Success extends Component {
  render() {
    const { contactPhone, contactPhoneSecondary } = this.props;

    return (
      <div className="mt-6">
        <Heading
          title={`Solicitarea ta a fost inregistrata!`}
          as="h3"
          display="h2"
        />

        <p className="mt-3">
          {`Pentru mai multe detalii, verifica adresa de email.`}
        </p>
        <p>{`Echipa Relatii Clienti.`}</p>

        {contactPhone && (
          <p>
            <span className="u-color-red">
              <sup>*</sup>
            </span>
            {`Daca in continuare ai nelamuriri, nu ezita sa ne contactezi la numarul de telefon:`}
            {` `}
            <a href={`tel:${contactPhone}`} className="inline-block">
              {contactPhone}
            </a>
            {contactPhoneSecondary && (
              <>
                {` `}
                {`sau`}
                {` `}
                <a
                  href={`tel:${contactPhoneSecondary}`}
                  className="inline-block"
                >
                  {contactPhoneSecondary}
                </a>
              </>
            )}
            .
          </p>
        )}
      </div>
    );
  }
}

export default Success;
